import { Buttons } from "../../atoms/Buttons";
import { InputRadio } from "../../atoms/Inputs/InputRadio";
import { InputSelect } from "../../atoms/Inputs/InputSelect";
import { InputText } from "../../atoms/Inputs/InputText";
import { SearchBar } from "../../molecules/SearchBar";
import * as S from "./DBBackupSection.style";

interface DBBackupSectionProps {
  autoBackupInputs: { bupAutoEnabled?: boolean; bupAutoInterval?: number };
  onChangeManualBackup: (name: "startTime" | "endTime", value: string) => void;
  onChangeAutoBackup: (
    name: "bupAutoEnabled" | "bupAutoInterval",
    value: string
  ) => void;
  onManualBackup: () => void;
  onAutoBackup: () => void;
}
export const DBBackupSection = ({
  autoBackupInputs,
  onChangeAutoBackup,
  onChangeManualBackup,
  onManualBackup,
  onAutoBackup,
}: DBBackupSectionProps) => {
  
  return (
    <S.DBBackupSection>
      <S.DBBackupSet>
        <SearchBar searchTitle="DB 수동백업" />
        <InputText
          type="datetime-local"
          label="기간선택"
          size="md"
          direction="column"
          onChange={(e) => onChangeManualBackup("startTime", e.target.value)}
        />
        <InputText
          type="datetime-local"
          size="md"
          endDate={true}
          direction="column"
          onChange={(e) => onChangeManualBackup("endTime", e.target.value)}
        />

        <S.DBText>
          ※ 수동백업 기간은 N일(n시간)이내로 지정이 가능합니다.
        </S.DBText>

        <S.DBButtonRow>
          <Buttons
            type="button"
            size="md"
            layout="primary"
            label="선택기간 백업"
            onClick={onManualBackup}
          />
        </S.DBButtonRow>
      </S.DBBackupSet>
      <S.DBBackupSet>
        <SearchBar searchTitle="DB 자동백업 설정" />
        <InputRadio
          label="자동백업 활성화"
          size="md"
          name="backup-active"
          direction="column"
          options={[
            { display: "끄기", value: "false" },
            { display: "켜기", value: "true" },
          ]}
          onChange={(e) => onChangeAutoBackup("bupAutoEnabled", e.target.value)}
          value={autoBackupInputs?.bupAutoEnabled?.toString()}
        />
        <InputSelect
          label="자동백업 간격"
          size="md"
          placeholder="백업간격 선택"
          direction="column"
          options={[
            { label: "1일", value: 1 },
            { label: "1주일", value: 7 },
          ]}
          onChange={(e) =>
            onChangeAutoBackup("bupAutoInterval", e.target.value)
          }
          value={autoBackupInputs?.bupAutoInterval?.toString()}
        />

        <S.DBButtonRow>
          <Buttons
            type="button"
            size="md"
            layout="primary"
            label="저장"
            onClick={onAutoBackup}
          />
        </S.DBButtonRow>
      </S.DBBackupSet>
    </S.DBBackupSection>
  );
};
